import { forwardRef, createElement } from 'react';

function IconWorkflow(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M19.144 16.292a2.853 2.853 0 00-2.754 2.144H7.722a2.857 2.857 0 01-2.856-2.858 2.857 2.857 0 012.856-2.859h1.53a2.842 2.842 0 005.508 0h1.529a4.286 4.286 0 004.283-4.287 4.286 4.286 0 00-4.283-4.288H7.62A2.856 2.856 0 002 4.859a2.856 2.856 0 005.62.715h8.669a2.857 2.857 0 012.855 2.858 2.857 2.857 0 01-2.855 2.858h-1.53a2.842 2.842 0 00-5.508 0h-1.53a4.286 4.286 0 00-4.283 4.288 4.286 4.286 0 004.284 4.287h8.668a2.85 2.85 0 005.6-.964 2.852 2.852 0 00-2.846-2.609zM4.866 6.288a1.429 1.429 0 11.002-2.857 1.429 1.429 0 01-.002 2.857zm7.14 4.287a1.429 1.429 0 11-.002 2.857 1.429 1.429 0 01.001-2.857zm7.138 10.005a1.429 1.429 0 11.002-2.857 1.429 1.429 0 01-.002 2.857z",
    fill: "currentColor"
  }));
}

var Workflow = /*#__PURE__*/forwardRef(IconWorkflow);

export default Workflow;
//# sourceMappingURL=Workflow.js.map
